<script setup>
import { useI18n } from 'vue-i18n';
import { formatDateTime } from '../utils';
import StatusBadge from './StatusBadge.vue';

defineProps({
  title: { type: String, required: true },
  versions: { type: Array, default: () => [] },
  selectedId: { type: [Number, String], default: null },
});

const emit = defineEmits(['select']);
const { t } = useI18n();
</script>

<template>
  <section class="p-4 border rounded-xl border-n-weak bg-n-solid-2">
    <h3 class="mb-3 text-sm font-semibold text-n-slate-12">{{ title }}</h3>
    <div class="flex flex-col gap-2">
      <button
        v-for="version in versions"
        :key="version.id"
        type="button"
        class="flex flex-col gap-2 p-3 text-left border rounded-lg"
        :class="
          Number(selectedId) === Number(version.id)
            ? 'border-n-brand bg-n-brand/5'
            : 'border-n-weak bg-n-alpha-1 hover:border-n-strong'
        "
        @click="emit('select', version.id)"
      >
        <span class="flex items-center justify-between gap-2">
          <span class="text-sm font-medium text-n-slate-12">
            {{
              t('AI_REVIEWS.COMMON.VERSION', {
                version: version.version_number,
              })
            }}
          </span>
          <StatusBadge :status="version.state" />
        </span>
        <span class="text-xs text-n-slate-11">
          {{
            version.published_at
              ? t('AI_REVIEWS.COMMON.UPDATED', {
                  time: formatDateTime(version.published_at),
                })
              : t('AI_REVIEWS.COMMON.CREATED', {
                  time: formatDateTime(version.created_at),
                })
          }}
        </span>
      </button>
    </div>
  </section>
</template>
